import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useSelfServeContextStore } from "./SelfServeContext";
export var useOrderToken = function useOrderToken() {
  var _selectedBrandOrder$b;
  var _useSelfServeContextS = useSelfServeContextStore(["selectedBrandOrder"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 1),
    selectedBrandOrder = _useSelfServeContextS2[0].selectedBrandOrder;
  var orderToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : (_selectedBrandOrder$b = selectedBrandOrder.brand_order) === null || _selectedBrandOrder$b === void 0 ? void 0 : _selectedBrandOrder$b.token;
  return {
    orderToken: orderToken
  };
};